import { Injectable } from "@angular/core";
import { Overlay } from "@angular/cdk/overlay";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { DrawerRef } from "@webapp/ui/drawer/abstracts/drawer-ref";
import { InternalDrawerBuilderForService } from "@webapp/ui/drawer/services/drawer-builder-service";
import { DrawerOptions } from "@webapp/ui/drawer/drawer.models";

@Injectable({ providedIn: "any" })
export class DrawerService {
  constructor(private overlay: Overlay) {}

  create<T = NzSafeAny, D = undefined, R = NzSafeAny>(options: DrawerOptions<T, D extends undefined ? unknown : D>): DrawerRef<T, R> {
    return new InternalDrawerBuilderForService<T, R>(this.overlay, options).getInstance();
  }
}
